const BroadcastActionTypes = {
  FETCH_BROADCAST_START: 'FETCH_BROADCAST_START',
  FETCH_BROADCAST_SUCCESS: 'FETCH_BROADCAST_SUCCESS',
  FETCH_BROADCAST_FAILED: 'FETCH_BROADCAST_FAILED',
  DESTROY_BROADCAST: 'DESTROY_BROADCAST',
};

export default BroadcastActionTypes;
